
export var viewerWidth = getWidth();
export var contentWidth = getContentWidth(viewerWidth);
export var viewerMode = getMode(viewerWidth);
export var mobileView = getMobileView(viewerMode);
export var isArabic = true;  //TODO: use lang instead of isArabic

export function setViewerWidth(){ viewerWidth=getWidth();}
export function setContentWidth(){ contentWidth=getContentWidth(viewerWidth);}
export function setViewerMode(){ viewerMode=getMode(viewerWidth);}
export function setMobileView(){ mobileView=getMobileView(viewerMode);}
export function setIsArabic(isAr){ isArabic=isAr;}

export function getWidth() { 
    // return 200;
    return window.innerWidth; 
}

export function getContentWidth(width) { 
    // return 350;
    if (width>1500) return 1200;
    return width*0.8;
}

export function getMode(width) { 
    var mode = 5
    if (width <= 1200) mode = 4
    if (width <= 1070) mode = 3
    if (width <= 800) mode = 2
    if (width <= 505) mode = 1
    if (width <= 300) mode = 0.9
    if (width <= 200) mode = 0.8
    return mode;
} 

export function getMobileView(mode) { 
    return mode <= 3;
}

